import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-repurchase',
  templateUrl: './repurchase.component.html',
  styleUrls: ['./repurchase.component.css','../app.component.css']
})
export class RepurchaseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/repurchase/repurchase.component.ts